export default {
  authUrl: null,
  adminApiUrl: null,
  lotteryApiUrl: null
};
